export class KullaniciGrupYetki {

  yetkiId: number;
  isAktif: boolean;
  
  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}
